export default "__VITE_ASSET__BYoY7Pff__"